import MovieSlider from './movie-slider.vue';
export default MovieSlider;